var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"max-site-width"},_vm._l((_vm.links),function(link,index){return _c('Link',{key:index,attrs:{"data":link}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }